import { render, staticRenderFns } from "./EditReceiverAddress.vue?vue&type=template&id=762d1213&"
import script from "./EditReceiverAddress.vue?vue&type=script&lang=ts&"
export * from "./EditReceiverAddress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports